import { getRefreshToken, clearTokens } from "@/utils/tokenService";
import api from "@/router/api";
import { iniciarTimerRenovacaoToken } from "@/utils/timerTokenRefresh";
import { useAuthStore } from "@/stores/auth";

export async function refreshAccessToken() {
  const auth = useAuthStore();
  auth.estaRenovando = true;
  try {
    const refreshToken = getRefreshToken();
    const response = await api.post("/autenticacao/refresh-tokens", {
      refreshToken,
    });

    const novoAccessToken = response.data.token;
    const novoRefreshToken = response.data.refreshToken;
    auth.atualizarSessao(novoAccessToken, novoRefreshToken);
    return { novoAccessToken, novoRefreshToken };
  } catch (error) {
    clearTokens();
    throw error;
  } finally {
    auth.estaRenovando = false;
  }
}

export async function autenticacaoLoginGex(email, senha) {
  const token = btoa(`${email}:${senha}`);
  const response = await api.post(
    "/autenticacao/login",
    {},
    {
      headers: {
        Authorization: `Basic ${token}`,
      },
    }
  );
  if (response.status === 200) {
    iniciarTimerRenovacaoToken();
  }
  return response;
}
